export class PublicationFeatured {
  id!: number;
  thumbnail!: string;
  slug!: string;
  translationKey!: string;
}
